import detection from '../../api/detection'
import { Message } from 'element-ui'

const state = {
  detectedList: [],
  loading: true
};

const actions = {
  // 获取检测列表
  async getDetection ({ commit }, payload) {
    const response = await detection.getDetection(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_GETDETECTION', {
        detectedList: data.pn_detections
      });
    }
  },
  // 创建检测
  async detect ({ dispatch, commit }, payload) {
    const response = await detection.detect(payload.data);
    if (response.status === 202) {
      Message.success('任务提交成功，请在任务列表中查看进度及结果。');
    }
  },
  async updateLoadingStatus ({ commit }, { loading }) {
    commit('UPDATE_LOADING', {
      loading: loading
    });
  }
};

const mutations = {
  'UPDATE_GETDETECTION': (state, payload) => {
    state.loading = false;
    state.detectedList = payload.detectedList;
  },
  'UPDATE_LOADING': (state, { loading }) => {
    state.loading = loading;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/detection.js